import { Select } from 'antd';

const { Option } = Select;

const ListDeroulanteShare = ({ options = [], disabled = false, onChange,value = [] }) => {
  const handleChange = (values) => {
    onChange(values); 
  };

  return (
    <Select
      mode="multiple"
      allowClear
      disabled={disabled}
      style={{ width: '100%' }}
      placeholder="Sélectionner"
      value={Array.isArray(value) ? value.filter(v => v !== null && v !== '') : []}
      onChange={handleChange}
    >
      {options.map((opt) => (
        <Option key={opt.value || opt} value={opt.value || opt}>
          {opt.label || opt}
        </Option>
      ))}
    </Select>
  );
};

export default ListDeroulanteShare;
